import type { OfficeApp, OfficeAppData } from 'owa-left-rail-utils/lib/store/schema/OfficeApp';
import type NavBarLinkData from 'owa-service/lib/contract/NavBarLinkData';
import { getNavBarLinkData } from 'owa-left-rail-utils/lib/utils/getNavBarLinkData';
import addSupportedAppsToStore from 'owa-left-rail-utils/lib/mutators/addSupportedAppsToStore';
import type NavBarData from 'owa-service/lib/contract/NavBarData';
import { getBposPromise } from 'owa-bpos-store';
import { isMOSLaunchPagesEnabled } from 'owa-left-rail-utils';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isConsumer } from 'owa-session-store';

// Makes call to getBposNavBarData to get the supported apps for this mailbox
export default function initializeSupportedOfficeRailApps() {
    const leftRailApps: OfficeApp[] = [
        'Word',
        'Excel',
        'Powerpoint',
        'OneNote',
        'db5e5970-212f-477f-a3fc-2227dc7782bf', // Communities
        '4c4ec2e8-4a2c-4bce-8d8f-00fc664a4e5b', // Bookings
    ];
    if (isMOSLaunchPagesEnabled() && isFeatureEnabled('mos-orgExplorer')) {
        leftRailApps.unshift('9b049ed6-fc8b-40c7-815b-bf84e344d270' /* Org Explorer */);
    }
    if (isFeatureEnabled('mos-appStore')) {
        leftRailApps.push('f3a6e67f-850d-4dd9-960a-04c6638ded36' /* App Store */);
    }

    if (isConsumer()) {
        filterAndAddAppsToStore(leftRailApps);
    } else {
        getBposPromise()?.then((navBarData: NavBarData) => {
            filterAndAddAppsToStore(leftRailApps, navBarData);
        });
    }
}

function filterAndAddAppsToStore(leftRailApps: OfficeApp[], navBarData?: NavBarData) {
    const appData: OfficeAppData[] = leftRailApps
        .map(app => {
            const navBarLinkData: NavBarLinkData = getNavBarLinkData(app, navBarData);
            if (navBarLinkData) {
                return {
                    app: app,
                    displayText: navBarLinkData.Text,
                    title: navBarLinkData.Title,
                    url: navBarLinkData.Url,
                };
            }
            return null;
        })
        .filter(data => !!data);

    if (appData?.length > 0) {
        addSupportedAppsToStore(appData);
    }
}
